/**
 * Returns true when the standard Promise-based RTCPeerConnection.getStats()
 * API is available. Detected via the presence of the RTCStatsReport global
 * constructor, which is defined in all environments that implement the
 * standard API.
 */
const shouldUseStandardGetStats = typeof RTCPeerConnection !== 'undefined' &&
  typeof RTCStatsReport !== 'undefined';
export default shouldUseStandardGetStats;
